// Default Expiration (7 days)
export const getDefaultExpiration = (): Date => {
    const date = new Date()
    date.setDate(date.getDate() + 7)

    return date
}
